var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/DefaultPanelRender/DefaultPanelRender.tsx";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import { ListItem, ListItemIcon, ListItemText, Skeleton, Typography } from '@mui/material';
import { List } from "./DefaultPanelRender.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DefaultPanelRender(_ref) {
  var item = _ref.item,
      activeItems = _ref.activeItems,
      onSelect = _ref.onSelect,
      ExplorerItem = _ref.ExplorerItem,
      loading = _ref.loading,
      getScrollElem = _ref.getScrollElem,
      emptyPanelTitle = _ref.emptyPanelTitle;
  var stubs = Array(item.skeletonTotal).fill(0);

  var renderBody = function renderBody() {
    var _item$children, _item$children2;

    if (!((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length)) {
      if (loading) {
        // TODO: вынести рендер скелетона в renderProp
        return stubs.map(function (_, idx) {
          var textWidth = 100 - Math.round(Math.random() * 70);
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsxs(ListItem, {
              dense: true,
              button: true,
              children: [/*#__PURE__*/_jsx(ListItemIcon, {
                children: /*#__PURE__*/_jsx(Skeleton, {
                  variant: "circular",
                  width: 20,
                  height: 20
                })
              }), /*#__PURE__*/_jsx(ListItemText, {
                disableTypography: true,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "body2",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    variant: "text",
                    width: "".concat(textWidth, "%")
                  })
                })
              })]
            }, idx)
          );
        });
      }

      return /*#__PURE__*/_jsx(EmptyPlaceholder, {
        emptyPanelTitle: emptyPanelTitle ? emptyPanelTitle : 'пусто'
      });
    }

    return (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.map(function (it) {
      return /*#__PURE__*/_jsx(ExplorerItem, {
        item: it,
        onSelect: onSelect,
        isSelected: activeItems.some(function (actIt) {
          return it.key === actIt.key;
        }),
        getScrollElem: getScrollElem
      }, it.key);
    });
  };

  return /*#__PURE__*/_jsx(List, {
    children: renderBody()
  });
}

var EmptyPlaceholder = function EmptyPlaceholder(_ref2) {
  var emptyPanelTitle = _ref2.emptyPanelTitle;
  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: '10px',
      textAlign: 'center'
    },
    children: /*#__PURE__*/_jsxs(Typography, {
      variant: "body2",
      color: "textSecondary",
      children: ["<", emptyPanelTitle, ">"]
    })
  });
};